import { render, staticRenderFns } from "./my_order_detail.vue?vue&type=template&id=16f57dc2&scoped=true&"
import script from "./my_order_detail.vue?vue&type=script&lang=js&"
export * from "./my_order_detail.vue?vue&type=script&lang=js&"
import style1 from "./my_order_detail.vue?vue&type=style&index=1&id=16f57dc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f57dc2",
  null
  
)

export default component.exports